export default "__VITE_ASSET__BH1KeR0S__"